import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTable } from '@angular/material/table';
import { finalize, Subject, takeUntil } from 'rxjs';
import { PartnerSubscriptionTypeMappingDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/partner-subscription-type-mapping-dto';
import { PartnerSubscriptionTypeService } from 'src/app/api/services';
import { EGIS_SERVICE_CALLER } from 'src/app/constants';
import { AuthService } from 'src/app/services/auth.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { LoaderService } from 'src/app/services/loader.service';
import { PartnerabonnementerEditDialogComponent } from '../partnerabonnementer-edit-dialog/partnerabonnementer-edit-dialog.component';
import { AuditHistoryEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/audit-history-enum';
import { HistoryViewComponent } from 'src/app/components/shared/history/history-view/history-view.component';
import { IHistoryView } from 'src/app/components/shared/history/history.model';

@Component({
  selector: 'app-partnerabonnementer-list',
  templateUrl: './partnerabonnementer-list.component.html',
  styleUrls: ['./partnerabonnementer-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PartnerAbonnementerListComponent implements OnInit {
  subscriptionstypes: PartnerSubscriptionTypeMappingDto[] = [];
  @ViewChild(MatTable) table: MatTable<any>;
  displayedColumns: string[] = [
    'partnerName',
    'subscriptionTypeName',
    'kundesegment',
    'maxOutput',
    'numberOfOutdoorParts',
    'includes24HourService',
    'includesFreeService',
    'ourPrice',
    'partnerPrice',
    'partnerSubscriptionTypeId',
    'actions',
  ];
  canEdit = this.auth.isAdministrator;

  unsubscribe$ = new Subject<void>();

  constructor(
    private service: PartnerSubscriptionTypeService,
    private auth: AuthService,
    private dialog: MatDialog,
    private loader: LoaderService,
    private errorHandler: ErrorHandlerService,
  ) {}

  ngOnInit(): void {
    this.getData();
  }

  async getData() {
    this.loader.show();
    await this.service
      .getAllPartnerSubscriptionTypeMappings({
        caller: EGIS_SERVICE_CALLER,
      })
      .pipe(
        finalize(() => {
          this.loader.hide();
        }),
        takeUntil(this.unsubscribe$),
      )
      .subscribe(
        (result: PartnerSubscriptionTypeMappingDto[]) => {
          this.subscriptionstypes = result;
        },
        (error) => {
          this.errorHandler.HandleError(error);
        },
      );
  }

  edit(row: PartnerSubscriptionTypeMappingDto) {
    const data = {
      partnerSubscriptionTypeMapping: row,
    };

    let dialogRef = this.dialog.open(PartnerabonnementerEditDialogComponent, {
      width: '600px',
      maxWidth: '95vw',
      data: data,
    });

    dialogRef.afterClosed().subscribe((p) => {
      if (p) {
        this.getData();
      }
    });
  }

  @ViewChild(HistoryViewComponent) historyViewComponent: HistoryViewComponent;
  historyView: IHistoryView;

  showhistory(row: PartnerSubscriptionTypeMappingDto) {
    this.historyView = {
      entityId: row.id,
      historyType: AuditHistoryEnum.Partnerabonnement,
      title: `${row.partnerSubscriptionTypeId} - ${row.partnerName}`,
    };
  }
}
